import { useHttpClient } from '@/common/api/httpClient';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import type { FeatureFlagResponse } from './models/featureFlagResponse';
import type { FeatureFlagRequest } from './models/featureFlagRequest';

export interface ToggleFeatureFlagResponse {
  ok: true;
  featureFlag: FeatureFlagResponse;
}

export function useToggleFeatureFlags() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute,
  };

  async function execute(featureFlag: FeatureFlagRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('featureflag'), {
      headers,
      method: 'POST',
      body: JSON.stringify(featureFlag),
    });

    const text = translations.value.featureFlags.actions.toggle;

    const response = await httpClient.action<ToggleFeatureFlagResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = (await response.json()) as FeatureFlagResponse;
        return {
          ok: true,
          featureFlag: json,
        };
      },
    });

    return response;
  }
}
